import React from "react";
import logo from "../../../../assets/images/logo/bizhoodfullLogo.png";
import {
  dateAndTimeFormatter,
  dateFormatter,
  getName,
} from "../../../../global-functions/globalFunctions";
import { Avatar } from "../../../../components/Avatar/Avatar";
import { useSelector } from "react-redux";
import CustomTooltip from "../../../../components/CustomTooltip/CustomTooltip";

const PrintDeals = React.forwardRef((props, ref) => {
  const user = useSelector((state) => state.user);
  const { dealDetails, allActivity } = props;

  return (
    <div ref={ref}>
      <div className="d-flex flex-column gap-3 p-5">
        <div lassName="d-flex justify-content-between align-items-end gap-3">
          <img src={logo} alt="sociohoodlogo" className="mw-175p mh-125p" />
        </div>
        <div className="justify-content-start mt-1 fs-5 text-dark px-3 bg-light">
          Deal Information
        </div>
        <div className="card card-border rounded-0 p-2">
          <div className="d-flex">
            <div className="col-6">
              <div className="d-flex">
                <div className="col-5 p-2 nowrap">
                  <span className="fs-7">1. Deal Name :</span>
                </div>
                <div className="col-7 p-2 border-start">
                  <span className="text-dark">{dealDetails?.title}</span>
                </div>
              </div>
              <div className="d-flex">
                <div className="col-5 p-2 nowrap">
                  <span className="fs-7">2. Assigned Group :</span>
                </div>
                <div className="col-7 p-2 border-start">
                  <span className="text-dark">
                    {dealDetails?.participantsGroupId?.length > 0 ? (
                      <>
                        {dealDetails?.participantsGroupId?.map(
                          (item, index) => {
                            return (
                              <span className="text-dark text-capitalize fw-bold text-center">
                                &nbsp;{index + 1}. {item?.name}
                              </span>
                            );
                          }
                        )}
                      </>
                    ) : (
                      "No Assigne Group"
                    )}
                  </span>
                </div>
              </div>
              <div className="d-flex">
                <div className="col-5 p-2 nowrap">
                  <span className="fs-7">3. Date Created :</span>
                </div>
                <div className="col-7 p-2 border-start">
                  <span className="text-dark">
                    {dateAndTimeFormatter(dealDetails?.createdAt)}
                  </span>
                </div>
              </div>
              <div className="d-flex">
                <div className="col-5 p-2 nowrap">
                  <span className="fs-7">4. Deal Creator :</span>
                </div>
                <div className="col-7 p-2 border-start">
                  <span className="text-dark text-capitalize">
                    {getName(
                      dealDetails?.createdBy
                        ? dealDetails?.createdBy
                        : dealDetails?.convertedBy,
                      user?._id
                    )}
                  </span>
                </div>
              </div>
              <div className="d-flex">
                <div className="col-5 p-2 nowrap">
                  <span className="fs-7">5. Assigned Participant :</span>
                </div>
                <div className="col-7 p-2 border-start">
                  <span className="text-dark text-capitalize">
                    {dealDetails?.assignedTo?.length > 0 ? (
                      <>
                        {dealDetails?.assignedTo?.map((item) => {
                          return (
                            <span className="d-flex align-items-center gap-2">
                              {item?.name},
                              <br />
                            </span>
                          );
                        })}
                      </>
                    ) : (
                      "-"
                    )}
                  </span>
                </div>
              </div>
            </div>

            <div className="col-6 border-start">
              <div className="d-flex">
                <div className="col-5 p-2 nowrap">
                  <span className="fs-7">6. Deal Amount :</span>
                </div>
                <div className="col-7 p-2 border-start">
                  <span className="text-dark text-capitalize">
                    {dealDetails?.amount ? `₹ ${dealDetails?.amount}` : "NA"}
                  </span>
                </div>
              </div>
              <div className="d-flex">
                <div className="col-5 p-2 nowrap">
                  <span className="fs-7">7. Closing Amount :</span>
                </div>
                <div className="col-7 p-2 border-start">
                  <span className="text-dark text-capitalize">
                    {dealDetails?.closingAmount
                      ? `₹ ${dealDetails?.closingAmount}`
                      : "NA"}
                  </span>
                </div>
              </div>
              <div className="d-flex">
                <div className="col-5 p-2 nowrap">
                  <span className="fs-7">8. Last Updated :</span>
                </div>
                <div className="col-7 p-2 border-start">
                  <span className="text-dark text-capitalize">
                    {dateAndTimeFormatter(dealDetails?.updatedAt)}
                  </span>
                </div>
              </div>
              <div className="d-flex">
                <div className="col-5 p-2 nowrap">
                  <span className="fs-7 h-20">9. Status Type : </span>
                </div>
                <div className="col-7 p-2 border-start">
                  <span className="h-20 text-dark text-capitalize">
                    {dealDetails?.initialStatusId?.name}
                  </span>
                </div>
              </div>
              <div className="d-flex">
                <div className="col-5 p-2 nowrap">
                  <span className="fs-7">10. Status Step : </span>
                </div>
                <div className="col-7 p-2 border-start">
                  <span className="text-dark text-capitalize">
                    {dealDetails?.subStatusId?.name}
                  </span>
                </div>
              </div>
              <div className="d-flex">
                <div className="col-5 p-2 nowrap">
                  <span className="fs-7">11. Deal Source : </span>
                </div>
                <div className="col-7 p-2 border-start">
                  <span className="text-dark text-capitalize">
                    {dealDetails?.source ? dealDetails?.source : "NA"}
                  </span>
                </div>
              </div>
              <div className="d-flex">
                <div className="col-5 p-2 nowrap">
                  <span className="fs-7">12. Description : </span>
                </div>
                <div className="col-7 p-2 border-start">
                  <span className="text-dark text-capitalize">
                    {dealDetails?.description ? dealDetails?.description : "NA"}
                  </span>
                </div>
              </div>

              {dealDetails?.additionalInfo?.length > 0 &&
                dealDetails?.additionalInfo?.map((fld, index) => {
                  return (
                    <div className="d-flex">
                      <div className="col-5 p-2 nowrap">
                        <span className="fs-7">
                          {" "}
                          {13 + index} . {fld?.fieldName} :
                        </span>
                      </div>
                      <div className="col-7 p-2 border-start">
                        <span className="text-dark">
                          {fld?.fieldValue ? fld?.fieldValue : "NA"}
                        </span>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>

        <div className="d-flex gap-2">
          <div className="justify-content-start mt-1 fs-5 text-dark px-3 col-sm-12 bg-light">
            Contact Info
          </div>
        </div>
        <div className="card card-border rounded-0">
          <div className="d-flex">
            <div className="col-sm-6 p-2">
              <div className="d-flex">
                <div className="col-sm-5 p-2 px-2 d-flex flex-column gap-2">
                  <span className="fs-7">1. Full Name : </span>
                  <span className="fs-7">2. Phone Number : </span>
                  <span className="fs-7">3. Email Address : </span>
                  <span className="fs-7">4. State : </span>
                </div>
                <div className="col-sm-7 p-2 px-3 border-start d-flex flex-column gap-2">
                  <span className="fs-7 text-dark text-capitalize">
                    {dealDetails?.contactId?.name
                      ? dealDetails?.contactId?.name
                      : "-"}
                  </span>
                  <span className="fs-7 text-dark text-capitalize">
                    {dealDetails?.contactId?.phone
                      ? dealDetails?.contactId?.phone
                      : "-"}
                  </span>
                  <span className="fs-7 text-dark text-capitalize">
                    {dealDetails?.contactId?.email
                      ? dealDetails?.contactId?.email
                      : "-"}
                  </span>
                  <span className="fs-7 text-dark text-capitalize">
                    {dealDetails?.contactId?.state
                      ? dealDetails?.contactId?.state
                      : "-"}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-sm-6 border-start p-2">
              <div className="d-flex">
                <div className="col-sm-4 p-2 px-2 d-flex flex-column gap-2">
                  <span className="fs-7">5. City : </span>
                  <span className="fs-7">6. Pincode : </span>
                  <span className="fs-7"> 7. Address : </span>
                </div>
                <div className="col-sm-8 p-2 px-3 border-start d-flex flex-column gap-2">
                  <span className="fs-7 text-dark text-capitalize">
                    {dealDetails?.contactId?.city
                      ? dealDetails?.contactId?.city
                      : "-"}
                  </span>
                  <span className="fs-7 text-dark">
                    {dealDetails?.contactId?.pinCode
                      ? dealDetails?.contactId?.pinCode
                      : "-"}
                  </span>
                  <span className="fs-7 text-dark text-capitalize">
                    {dealDetails?.contactId?.address
                      ? dealDetails?.contactId?.address
                      : "-"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div
          className="justify-content-start fs-5 text-dark px-3"
          style={{ backgroundColor: "#E3EDFF" }}
        >
          Timeline
        </div>
        <table id="datable_1" className="table table-bordered">
          <thead
            style={{
              backgroundColor: "#EDF2FF",
              border: "#fff",
              borderRadius: "16px",
            }}
          >
            <tr className="text-center">
              <th style={{ borderBottom: "none" }}>Process No .</th>
              <th style={{ borderBottom: "none" }}>Date & Time</th>
              <th style={{ borderBottom: "none" }}>Action </th>
              <th style={{ borderBottom: "none", textAlign: "left" }}>
                Updated By
              </th>
              <th style={{ borderBottom: "none", textAlign: "left" }}>
                Updated for
              </th>
            </tr>
          </thead>
          <tbody>
            {dealDetails?.dealLifeCycle
              ?.slice()
              ?.reverse()
              ?.map((log, index) => (
                <tr className="text-center">
                  <td>{dealDetails?.dealLifeCycle?.length - index}.</td>
                  <td> {dateAndTimeFormatter(log?.date)}</td>
                  <td className="text-capitalize text-dark">
                    {log?.description}

                    {log?.moreInfo?.[0]?.actionFromRef && (
                      <span className="badge badge-sm badge-primary ms-1 fw-bold">
                        {log?.moreInfo?.[0]?.actionFromRef === "Status"
                          ? "Auto"
                          : "Manual"}
                      </span>
                    )}
                  </td>
                  <td style={{ textAlign: "left" }}>
                    {" "}
                    <Avatar
                      name={log?.updatedBy?.name}
                      count={1}
                      image={log?.updatedBy?.image}
                      size="xss"
                      color="primary"
                    />
                    &nbsp;
                    {getName(log?.updatedBy, user?._id)}
                  </td>
                  <td style={{ textAlign: "left" }}>
                    {" "}
                    {log?.updatedFor?.[0]?.name ? (
                      <>
                        <Avatar
                          name={log?.updatedFor?.[0]?.name}
                          count={1}
                          image={log?.updatedFor?.[0]?.image}
                          size="xss"
                          color="primary"
                        />
                        &nbsp;
                        {getName(log?.updatedFor?.[0], user?._id)}
                      </>
                    ) : (
                      "No Assignee"
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table> */}

        <div className="d-flex gap-2">
          <div className="justify-content-start mt-1 fs-5 text-dark px-3 col-sm-12 bg-light">
            Activity
          </div>
        </div>
        {allActivity?.length > 0 ? (
          <div className="border rounded-0 overflow-hide">
            {allActivity?.length > 0 && (
              <table className="table fs-7 text-dark text-capitalize mb-0">
                <thead>
                  <tr className="nowrap">
                    <th>Type</th>
                    <th>Title</th>
                    <th>Status</th>
                    <th className="text-center">Deadline</th>
                    <th>Assignees</th>
                    <th className="text-center">Last Modified</th>
                  </tr>
                </thead>
                <tbody>
                  {allActivity?.map((act) => {
                    return (
                      <tr>
                        <td style={{ verticalAlign: "top" }}>
                          <span className="d-flex align-items-center gap-1 flex-wrap">
                            {act?.taskType === "task" ? (
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="w-20"
                              >
                                <path
                                  d="M9.615 20H7C6.46957 20 5.96086 19.7893 5.58579 19.4142C5.21071 19.0391 5 18.5304 5 18V6C5 5.46957 5.21071 4.96086 5.58579 4.58579C5.96086 4.21071 6.46957 4 7 4H15C15.5304 4 16.0391 4.21071 16.4142 4.58579C16.7893 4.96086 17 5.46957 17 6V14M14 19L16 21L20 17M9 8H13M9 12H11"
                                  stroke="#979797"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            ) : act?.taskType === "meeting" ? (
                              <svg
                                width="26"
                                height="26"
                                viewBox="0 0 37 37"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect width="37" height="37" fill="white" />
                                <path
                                  d="M24.0908 18.1947L27.5765 16.0699L27.6738 20.151L24.0908 18.1947Z"
                                  stroke="#979797"
                                />
                                <rect
                                  x="7.5"
                                  y="13.5"
                                  width="15.9305"
                                  height="9.80051"
                                  rx="4.90025"
                                  stroke="#979797"
                                />
                              </svg>
                            ) : act?.taskType === "call" ? (
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="w-20"
                              >
                                <path
                                  d="M17.2647 12.7223C17.1102 12.7223 16.9486 12.673 16.7941 12.6377C16.4811 12.5686 16.1735 12.4767 15.8738 12.363C15.5478 12.2441 15.1896 12.2502 14.868 12.3803C14.5463 12.5104 14.284 12.7552 14.1315 13.0675L13.9769 13.3846C13.2927 13.0028 12.6639 12.5287 12.1082 11.9755C11.5566 11.4181 11.0838 10.7875 10.7032 10.1013L10.9983 9.90402C11.3097 9.75107 11.5538 9.48799 11.6835 9.16541C11.8132 8.84284 11.8193 8.48355 11.7008 8.15669C11.5892 7.85543 11.4977 7.5471 11.4268 7.23371C11.3917 7.0787 11.3636 6.91665 11.3425 6.7546C11.2572 6.25832 10.998 5.80889 10.6116 5.48725C10.2252 5.16561 9.73701 4.9929 9.23492 5.00022H7.12735C6.82459 4.99737 6.52477 5.05998 6.2483 5.18379C5.97182 5.30759 5.7252 5.48968 5.5252 5.71767C5.32521 5.94566 5.17655 6.21419 5.08933 6.50498C5.00211 6.79577 4.9784 7.10199 5.01979 7.4028C5.39405 10.3545 6.73818 13.097 8.83986 15.1972C10.9415 17.2973 13.681 18.6354 16.6255 19H16.8924C17.4105 19.0008 17.9106 18.8101 18.2975 18.4645C18.5197 18.2652 18.6973 18.0208 18.8184 17.7475C18.9395 17.4742 19.0014 17.1783 19 16.8792V14.7655C18.9914 14.2761 18.8137 13.8049 18.4972 13.4323C18.1807 13.0596 17.7451 12.8087 17.2647 12.7223ZM17.616 16.9497C17.6159 17.0497 17.5945 17.1486 17.5533 17.2397C17.5121 17.3308 17.4521 17.4121 17.3772 17.4781C17.2987 17.5461 17.2069 17.5969 17.1077 17.6272C17.0085 17.6575 16.904 17.6668 16.8011 17.6543C14.1701 17.3159 11.7262 16.1088 9.85505 14.2232C7.98387 12.3377 6.79184 9.88101 6.46698 7.24075C6.4558 7.13754 6.4656 7.03314 6.49579 6.93383C6.52598 6.83453 6.57592 6.7424 6.64261 6.66301C6.70845 6.58785 6.78948 6.52762 6.88033 6.48631C6.97118 6.44501 7.06976 6.42358 7.16951 6.42345H9.27707C9.44044 6.41981 9.59997 6.47339 9.72819 6.57498C9.85642 6.67658 9.94532 6.81982 9.97959 6.98006C10.0077 7.17264 10.0428 7.36288 10.085 7.55076C10.1661 7.92217 10.2741 8.28716 10.4081 8.64284L9.4246 9.10081C9.34051 9.13951 9.26486 9.19448 9.20201 9.26258C9.13916 9.33067 9.09034 9.41055 9.05836 9.49762C9.02637 9.58469 9.01185 9.67724 9.01563 9.76996C9.0194 9.86267 9.0414 9.95372 9.08037 10.0379C10.0914 12.2099 11.8323 13.9559 13.998 14.9699C14.1691 15.0403 14.3609 15.0403 14.5319 14.9699C14.6196 14.9384 14.7001 14.8899 14.7688 14.827C14.8375 14.7641 14.8931 14.6881 14.9324 14.6035L15.3679 13.6171C15.7311 13.7474 16.1018 13.8556 16.4779 13.9412C16.6653 13.9835 16.8549 14.0187 17.047 14.0469C17.2067 14.0813 17.3496 14.1704 17.4509 14.299C17.5522 14.4276 17.6056 14.5876 17.602 14.7515L17.616 16.9497Z"
                                  fill="#979797"
                                />
                              </svg>
                            ) : (
                              ""
                            )}
                            {act?.taskType}

                            <span className="fs-8 bg-light px-1 rounded text-secondary">
                              {act?.actionFromRef === "Status"
                                ? "Auto"
                                : "Manual"}
                            </span>
                          </span>
                        </td>
                        <td style={{ verticalAlign: "top" }}>{act?.title}</td>
                        <td style={{ verticalAlign: "top" }}>
                          {act?.activityStatus?.name}
                        </td>
                        <td
                          className="text-center fw-semibold fs-8"
                          style={{ verticalAlign: "top" }}
                        >
                          {act?.dealLineDate
                            ? dateAndTimeFormatter(act?.dealLineDate)
                            : "-"}
                        </td>
                        <td style={{ verticalAlign: "top" }}>
                          {act?.assignees?.length > 0 ? (
                            <>
                              {act?.assignees?.map((assignee) => {
                                return (
                                  <>
                                    {assignee?.name},<br />
                                  </>
                                );
                              })}
                            </>
                          ) : (
                            <span className="text-secondary fs-8">
                              No assignee
                            </span>
                          )}
                        </td>
                        <td
                          className="text-center fw-semibold fs-8"
                          style={{ verticalAlign: "top" }}
                        >
                          {dateAndTimeFormatter(act?.updatedAt)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
            {allActivity?.length === 0 && (
              <div className="d-flex flex-column col-12 align-content-center align-items-center h-100">
                <span className="text-secondary p-4 mt-3 font-4">
                  No Activity Added.
                </span>
              </div>
            )}
          </div>
        ) : (
          <div className="text-center text-secondary fs-4">
            No activity found
          </div>
        )}
      </div>
    </div>
  );
});

export default PrintDeals;
